if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class extends HTMLElement {
		connectedCallback() {
			var productId = this.dataset.productId;
			var sectionId = this.dataset.sectionId;
			var limit = this.dataset.limit || 9;

			fetch(
				'/recommendations/products?section_id=' + sectionId +
				'&product_id=' + productId +
				'&limit=' + limit
			)
				.then(function (res) { return res.text(); })
				.then(function (html) {
					var doc = new DOMParser().parseFromString(html, 'text/html');
					var newList = doc.querySelector('[data-catalog-list]');
					var currentList = this.querySelector('[data-catalog-list]');
					if (newList && currentList && newList.children.length > 0) {
						currentList.innerHTML = newList.innerHTML;
						if (typeof window.initProductParallax === 'function') {
							window.initProductParallax(currentList);
						}
					}
				}.bind(this));
		}
	});
}